import { FieldOverride, FieldOverrideObject } from '@/bpc/types/FieldOverride';

export const FIELD_OVERRIDES: FieldOverrideObject = {
  'business_information.is_registered': FieldOverride.YesNo,
  'business_information.subject_to_vat': FieldOverride.YesNo,
  'business_information.should_auto_capture_orders': FieldOverride.YesNo,
  'in_stores.business_concepts': FieldOverride.BusinessConcepts,
  'business_information.product_channel': FieldOverride.BusinessConcepts,
  sensitive_goods: FieldOverride.BusinessConcepts,
  business_size: FieldOverride.BusinessSizeComponent,
  'mor_entity_answers.licensing': FieldOverride.Radio,
  'mor_business_information.has_nominee_shareholders': FieldOverride.YesNo,
  'mor_business_information.issue_bearer_shares': FieldOverride.YesNo,
  'mor_group_answers.is_applicable_for_group_onboarding': FieldOverride.YesNo,
  'mor_group_answers.has_gambling_segment': FieldOverride.YesNo,
  'mor_group_answers.gambling_is_high_risk': FieldOverride.YesNo,
  'mor_group_answers.has_crypto_segment': FieldOverride.YesNo,
  'mor_group_answers.crypto_is_high_risk': FieldOverride.YesNo,
  'mor_group_answers.has_adult_service_segment': FieldOverride.YesNo,
  'mor_group_answers.adult_service_is_high_risk': FieldOverride.YesNo,
  'mor_group_answers.has_financial_services_segment': FieldOverride.YesNo,
  'mor_group_answers.financial_service_is_high_risk': FieldOverride.YesNo,
  'mor_group_answers.has_independent_testing_mechanism': FieldOverride.YesNo,
  'mor_group_answers.has_aml_ctf_findings': FieldOverride.YesNo,
  'mor_group_answers.has_cdd_kyc_backlog': FieldOverride.YesNo,
  'mor_group_answers.entrust_other_contracted_entities': FieldOverride.YesNo,
  'mor_group_answers.has_risk_classification': FieldOverride.YesNo,
  'mor_group_answers.interval_is_risk_based': FieldOverride.YesNo,
  'mor_group_answers.nested_model_signing_entity': FieldOverride.Radio,
  'mor_group_answers.nested_model_payouts_processor': FieldOverride.Radio,
  'mor_group_answers.distributor_sanction_management': FieldOverride.YesNo,
  'mor_group_answers.distributors_prohibited_lists_adherence_is_ensured': FieldOverride.YesNo,
  'mor_group_answers.distributors_prohibited_lists_awareness_is_ensured': FieldOverride.YesNo,
  'mor_group_answers.distributors_has_questionnaire': FieldOverride.YesNo,
  'mor_group_answers.has_event_driven_reviews': FieldOverride.YesNo,
  'mor_group_answers.verify_collected_info': FieldOverride.YesNo,
  'mor_group_answers.has_watch_list': FieldOverride.YesNo,
  'mor_group_answers.utilize_watch_list': FieldOverride.YesNo,
  'mor_group_answers.has_process_for_simplified_due_diligence': FieldOverride.YesNo,
  'mor_group_answers.has_process_for_enhanced_due_diligence': FieldOverride.YesNo,
  'mor_group_answers.has_pep_screening': FieldOverride.YesNo,
  'mor_group_answers.pep_screening_frequency': FieldOverride.Radio,
  'mor_group_answers.has_adverse_media_screening': FieldOverride.YesNo,
  'mor_entity_answers.obtain_financial_license': FieldOverride.YesNo,
  'mor_entity_answers.switch_partner_bank': FieldOverride.YesNo,
  'mor_entity_answers.notify_klarna': FieldOverride.YesNo,
  'mor_entity_answers.is_signing': FieldOverride.YesNo,
  'mor_entity_answers.is_operating_in_high_risk_segments': FieldOverride.YesNo,
  'mor_entity_answers.has_supplementary_partner_data': FieldOverride.YesNo,
  'mor_entity_answers.has_risk_rate': FieldOverride.YesNo,
  'mor_entity_answers.has_collateral_requirements': FieldOverride.YesNo,
  'mor_entity_answers.has_adjusting_trading_terms': FieldOverride.YesNo,
  'mor_entity_answers.has_adjusting_credit_terms': FieldOverride.YesNo,
  'mor_group_answers.has_live_sanction_screening': FieldOverride.YesNo,
  'mor_group_answers.has_transaction_sanction_screening': FieldOverride.YesNo,
  'mor_group_answers.has_sectoral_sanctions_control': FieldOverride.YesNo,
  'mor_group_answers.has_us_transaction_sanction_screening': FieldOverride.YesNo,
  'mor_group_answers.has_fraud_detection': FieldOverride.YesNo,
  'mor_group_answers.is_compliant_with_prohibited_lists': FieldOverride.YesNo,
  'mor_group_answers.has_prohibited_lists_review_process': FieldOverride.YesNo,
  'mor_group_answers.has_web_scraping_for_prohibited_lists': FieldOverride.YesNo,
  'mor_group_answers.has_kpi_for_aml_program': FieldOverride.YesNo,
  'mor_group_answers.has_requirement_for_suspicious_activity_reporting': FieldOverride.YesNo,
  'mor_group_answers.will_operate_in_us': FieldOverride.YesNo,
  'mor_group_answers.has_transaction_monitoring': FieldOverride.YesNo,
  'mor_group_answers.has_live_transaction_sanction_screening': FieldOverride.YesNo,
  'mor_group_answers.percentage_of_high_and_significant_high_risk': FieldOverride.Radio,
  'mor_group_answers.sanction_screening_performer': FieldOverride.Radio,
  'mor_group_answers.disputes_handling_by': FieldOverride.Radio,
  'mor_group_answers.cdd_conducted_phase': FieldOverride.Radio,
  'mor_entity_answers.average_timeframe_for_fulfilling_order': FieldOverride.Radio,
  'mor_entity_answers.average_interval_for_settling_fund': FieldOverride.Radio,
  'mor_entity_answers.escrow_account': FieldOverride.Radio,
};
